<span #animatedDigit>
    <span>{{digit}}</span>
</span>